import { ContainerId, PlacementId } from '@schibsted-nmp/advertising-companion';
import React from 'react';
import { useAppConfig } from '../../../AppConfig';
import { AdvertisingWrapper } from '../AdvertisingPlacement';
import { useToriBottomBannerDisplay } from '../tori/ToriBottomBannerDisplay';

const overflowStyle: React.CSSProperties = {
    direction: 'rtl',
};

type ToriBottomBannerProps = {
    className?: string;
};

export function ToriBottomBanner(props: ToriBottomBannerProps) {
    const { className } = props;

    const { isProbablyMobile } = useAppConfig();
    const { bottomBannerRef, shouldDisplayBottomBannerOnDesktop } =
        useToriBottomBannerDisplay();

    const shouldDisplay =
        isProbablyMobile || shouldDisplayBottomBannerOnDesktop;

    return (
        <div ref={bottomBannerRef}>
            {shouldDisplay && (
                <AdvertisingWrapper
                    className={className}
                    containerId={ContainerId.Bottom1}
                    placementId={PlacementId.Bottom1}
                    style={overflowStyle}
                />
            )}
        </div>
    );
}
